import { use } from 'react'
import { InternalShortcutContext } from './InternalShortcutContext'

export const useShortcutContext = () => {
  return use(InternalShortcutContext)
}
